/**
 * Chart colours for the Ads pool tab: the same validated categorical slots as the Organic tab
 * (slot 1 blue, 2 orange, 3 green, 4 amber) plus neutrals. Colour follows the MEANING, never the rank:
 * a clean match is always blue, a guessed (ambiguous) match always orange, an after-hold guess always
 * amber, and the same line keeps its colour on every chart.
 */
import { organicPalette } from '../organic/organicPalette';

export interface AdsPoolPalette {
    clean: string;
    ambiguous: string;
    afterHold: string;
    none: string;
    newMatched: string;
    newUnmatched: string;
    pool: string;
    callAsset: string;
    mapsAd: string;
    mapsMontreal: string;
    mapsToronto: string;
    /** One colour per configured default / pool-full line, in the order the RPC returns them. */
    configured: string[];
    unsplit: string;
    legacy: string;
    sim150: string;
    // shared with the Organic panels (scorecard, pool chart, funnel)
    matched: string;
    unmatched: string;
    grid: string;
    axis: string;
    muted: string;
    good: string;
    warning: string;
    critical: string;
    waiting: string;
}

export const adsPoolPalette = (mode: 'light' | 'dark'): AdsPoolPalette => {
    const o = organicPalette(mode);
    return {
        clean: o.matched,
        ambiguous: o.unmatched,
        afterHold: o.gbp,
        none: o.other,
        newMatched: o.canonical,
        newUnmatched: o.axis,
        pool: o.matched,
        callAsset: o.canonical,
        mapsAd: o.gbp,
        mapsMontreal: o.other,
        mapsToronto: mode === 'dark' ? '#8d7fe0' : '#6f5fd0',
        configured: [o.unmatched, o.gbp, mode === 'dark' ? '#e07fb0' : '#c2477f', mode === 'dark' ? '#5fb8c9' : '#1f8a9e'],
        unsplit: o.axis,
        legacy: o.matched,
        sim150: o.unmatched,
        matched: o.matched,
        unmatched: o.unmatched,
        grid: o.grid,
        axis: o.axis,
        muted: o.muted,
        good: o.good,
        warning: o.warning,
        critical: o.critical,
        waiting: o.waiting,
    };
};
